<template>
  <div class="pa-5">
    <v-flex id="header-container">
      <div class="d-flex align-center">
        <p class="headline d-inline-block mb-0">
          {{ ivrTemplate.name || 'Cargando...' }}
        </p>
        <v-btn fab icon small @click="ivrDialog = true" :disabled="isLoading">
          <v-icon>
            fas fa-pencil-alt
          </v-icon>
        </v-btn>
      </div>
      <v-select id="header-select" v-if="hasStaging" v-model="index" :items="versions" class="white--text" color="grey"
        solo>
      </v-select>
    </v-flex>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card class="elevation-2 white">
          <v-card-text class="pa-0">
            <flow-tree
              :key="flowKey"
              :data="flow"
              @edit-intention="editIntention" />
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap mt-3 v-if="!isLoading">
      <v-flex xs12 class="text-xs-right">
        <v-btn class="k-orange-linear white--text mr-0" large @click="startSave" :disabled="isNubank">
          Guardar
        </v-btn>
      </v-flex>
    </v-layout>
    <ivr-dialog
      :show="ivrDialog"
      :title="ivrDialogTitle"
      :data="ivrDialogData"
      :show-types="false"
      :newIvr="newIvr"
      @close="ivrDialog = false"
      @save="editivrTemplate">
    </ivr-dialog>
    <text-dialog
      :show="textDialog"
      :data="activeIntentionData"
      :title="activeTitle"
      :send-call-center-option="activeIntention.send_call_center"
      @save="saveIntention"
      @close="textDialog = false" />
    <question-dialog
      :show="questionDialog"
      :data="activeIntentionData"
      :title="activeTitle"
      @save="saveIntention"
      @close="questionDialog = false"/>
    <double-check 
      :show="showChecker"
      @close="showChecker = false"
      @accept="doubleCheckPassed"/>
  </div>
</template>

<script>
import IvrDialog from '@/components/ivr_v2/IvrDialog';
import FlowTree from '@/components/ivr_v2/Detail/FlowTree';
import TextDialog from '@/components/ivr_v2/Detail/TextDialog';
import DoubleCheck from '@/components/templateV2/modal/DoubleCheck';
import QuestionDialog from '@/components/ivr_v2/Detail/QuestionDialog';
import EventBus from '@/event-bus';
import _ from 'lodash';

const uuidv1 = require('uuid/v1');

export default {
  components: {
    IvrDialog,
    FlowTree,
    DoubleCheck,
    TextDialog,
    QuestionDialog,
  },
  data() {
    return {
      // Templates vars
      showChecker: false,
      index: 'actual',
      templates: {},
      versions: [
        {
          value: 'actual',
          text: 'Actual',
        },
        {
          value: 'staging',
          text: 'Próxima carga',
        },
      ],
      stagingActive: false,
      hasStaging: false,
      createStaging: false,
      // Old versions vars
      isLoading: true,
      newIvr: true,
      ivrDialog: false,
      textDialog: false,
      questionDialog: false,
      paymentPromiseDialog: false,
      activeIntention: {},
      currentParent: '',
      flowKey: uuidv1(),
      ivrTemplate: {},
      saleFlow: [
        {
          icon: 'fas fa-home',
          title: 'Saludo inicial',
          name: 'WELCOME',
          data: {
            text: '',
            afternoon_text: '',
          },
        },
        {
          icon: 'fas fa-question',
          title: 'Confirmación cliente',
          name: 'CUSTOMER_CONFIRMATION',
          data: {
            text: '',
            fallback_text: '',
            failed_attempts_text: '',
            max_attempts: 3,
            sms: [
              {
                status_id: 13,
                text: '',
                enabled: false,
              },
              {
                status_id: 33,
                text: '',
                enabled: false,
              },
            ],
          },
          childrens: [
            {
              icon: 'fas fa-check',
              title: 'Dar oferta',
              name: 'GIVE_OFFER',
              data: {
                text: '',
                fallback_text: '',
                failed_attempts_text: '',
                max_attempts: 3,
              },
              childrens: [
                {
                  icon: 'fas fa-check-double',
                  title: 'Acepta oferta',
                  name: 'OFFER_ACCEPTED',
                  send_call_center: true,
                  data: {
                    text: '',
                    send_call_center: false,
                    call_center_number: '',
                  },
                },
                {
                  icon: 'fas fa-thumbs-down',
                  title: 'Rechaza oferta',
                  name: 'OFFER_DECLINED',
                  send_call_center: true,
                  data: {
                    text: '',
                    send_call_center: false,
                    call_center_number: '',
                  },
                },
              ],
            },
            {
              icon: 'fas fa-times',
              title: 'Confirmación de recado',
              name: 'ASK_RELATIONSHIP',
              data: {
                text: '',
                fallback_text: '',
                failed_attempts_text: '',
                max_attempts: 3,
              },
              childrens: [
                {
                  icon: 'fas fa-user-check',
                  title: 'Conoce al cliente',
                  name: 'LEAVE_MESSAGE',
                  data: {
                    text: '',
                  },
                },
                {
                  icon: 'fas fa-user-times',
                  title: 'No conoce al cliente',
                  name: 'WRONG_PERSON',
                  data: {
                    text: '',
                  },
                },
              ],
            },
          ],
        },
        {
          icon: 'fas fa-phone-slash',
          title: 'Despedida',
          name: 'GOODBYE',
          data: {
            text: '',
          },
        },
      ],
      plainFlow: [
        {
          icon: 'fas fa-home',
          title: 'Mensaje',
          name: 'WELCOME',
          data: {
            text: '',
            afternoon_text: '',
          },
        },
      ],
      flow: [],
    };
  },
  created() {
    Promise.all([
      this.axios.get(`ivr_templates/${this.$route.params.ivrTemplate}`).then(({ data }) => data),
      this.axios.get(`/templates/staging/ivr/${this.$route.params.ivrTemplate}`).then(({ data }) => data),
      // this.axios.get('check_release', { params: { name: 'new_ivr' } })
      //   .then(({ data }) => {
      //     this.newIvr = data.is_active;
      //   })
      //   .catch(() => {
      //     this.newIvr = false;
      //   }),
    ]).then((data) => {
      const [template] = data;
      const [,[staging]] = data;
      this.templates.actual = template;
      this.setFlow(template);
      if (staging) {
        this.templates.staging = {
          name: (template || {}).name,
          id: staging.template_id,
          body: staging.body,
          type: staging.type,
          voice: staging.voice,
        };
        this.hasStaging = true;
      }
    });
  },
  computed: {
    getKey() {
      return this.ivrTemplate.key || null;
    },
    ivrDialogTitle() {
      return `Editar plantilla ${this.ivrTemplate.name}`;
    },
    ivrDialogData() {
      return {
        name: this.ivrTemplate.name,
        voice: this.ivrTemplate.voice,
      };
    },
    activeIntentionData() {
      return this.activeIntention.data || {};
    },
    activeTitle() {
      const intentionTitle = String(this.activeIntention.title).toLowerCase();
      return `Editar texto de ${intentionTitle}`;
    },
    isNubank() {
      return (
        parseInt(this.ivrTemplate.id, 10) === 98
        || parseInt(this.ivrTemplate.id, 10) === 99
        || parseInt(this.ivrTemplate.id, 10) === 100
        || parseInt(this.ivrTemplate.id, 10) === 101
      );
    },
  },
  methods: {
    // Template staging && Double check methods
    doubleCheckPassed(e) {
      if (e.value === 'after load') {
        this.createStaging = true;
      }
      this.save();
    },
    startSave() {
      if (this.hasStaging) {
        this.save();
      } else {
        this.showChecker = true;
      }
    },
    // Flow Methods
    map(flow, item) {
      const intention = {
        ...item,
      };
      const data = {};
      Object.keys(item.data).forEach((key) => {
        const value = flow[item.name][key];
        if (value !== undefined) {
          data[key] = value;
        }
      });
      intention.data = {
        ...intention.data,
        ...data,
      };
      if (item.childrens) {
        item.childrens.forEach((item2, i) => {
          intention.childrens[i] = {
            ...item.childrens[i],
            ...this.map(flow, item2),
          };
        });
      }
      return intention;
    },
    setFlow(data) {
      this.flow = [
        ...this[`${_.camelCase(data.type)}Flow`],
      ];

      const flow = JSON.parse(data.body);
      if (Object.keys(flow).length) {
        const tmpFlow = [
          ...this.flow,
        ];
        for (let i = 0; i < tmpFlow.length; i += 1) {
          tmpFlow[i] = this.map(flow, tmpFlow[i]);
        }
        this.flow = [
          ...tmpFlow,
        ];
      }
      this.ivrTemplate = data;
      this.ivrTemplate.key = uuidv1();
      this.isLoading = false;
    },
    buildFlow() {
      const flow = {};
      const map = (item) => {
        flow[item.name] = {
          ...item.data,
        };
        if (item.childrens) {
          item.childrens.forEach((item2) => {
            map(item2);
          });
        }
      };
      this.flow.forEach(map);
      return { body: flow, textMissing: this.textMissing(flow) };
    },
    textMissing(flow) {
      const flowKeys = Object.keys(flow);
      let textMissing = false;
      loop1: // eslint-disable-line
      for (let i = 0; i < flowKeys.length; i += 1) {
        const currentKey = flowKeys[i];
        const textKeys = Object.keys(flow[currentKey]).filter(key => key.includes('text'));
        for (let b = 0; b < textKeys.length; b += 1) {
          if (!flow[currentKey][textKeys[b]]) {
            EventBus.$emit('modal', 'Faltan textos');
            textMissing = true;
            break loop1; // eslint-disable-line
          }
        }
      }
      return textMissing;
    },
    // Old methods
    editivrTemplate(form) {
      this.ivrTemplate.name = form.name;
      this.ivrTemplate.voice = form.voice;
      this.ivrDialog = false;
    },
    editIntention({ intention, parent }) {
      this.currentParent = parent;
      this.activeIntention = intention;
      this.blurDialog(true);
    },
    blurDialog(val) {
      if (
        this.activeIntention.name === 'CUSTOMER_CONFIRMATION'
        || this.activeIntention.name === 'ASK_RELATIONSHIP'
        || this.activeIntention.name === 'GIVE_OFFER'
        || (
          (this.ivrTemplate || {}).type === 'no_commitment'
          && this.activeIntention.name === 'NO_COMMITMENT'
        )
        || (
          this.activeIntention.name === 'COLLECT'
          && (this.ivrTemplate || {}).type !== 'customer_confirmation'
        )
        || this.activeIntention.name === 'MAIL_CONFIRMATION'
      ) {
        this.questionDialog = val;
      } else if (this.activeIntention.name === 'PAYMENT_PROMISE') {
        this.paymentPromiseDialog = val;
      } else {
        this.textDialog = val;
      }
    },
    saveIntention(form) { // eslint-disable-line
      const obj = [
        ...this.flow,
      ];
      const arr = this.currentParent.slice(0, this.currentParent.length - 1)
        .replace(/\[/g, '')
        .split(']');
      let position = '';
      for (let i = 0; i < arr.length; i += 1) {
        position += `[${arr[i]}]`;
        if (i !== arr.length - 1) {
          position += '.childrens';
        }
      }
      const str = `obj${position}.data`;
      // eslint-disable-next-line
      eval(`${str} = {
        ...${str},
        ...form,
      };`);
      this.flow = [
        ...obj,
      ];
      this.flowKey = uuidv1();
      this.blurDialog(false);
    },
    save() {
      const flow = this.buildFlow();
      if (!flow.textMissing) {
        if (this.index === 'actual' && !this.createStaging) {
          const url = this.newIvr ? 'ivr_templates/v2' : 'ivr_templates';
          this.axios.patch(`${url}/${this.ivrTemplate.id}`, {
            name: this.ivrTemplate.name,
            voice: this.ivrTemplate.voice,
            body: JSON.stringify(flow.body),
          })
            .then(() => {
              this.templates.actual = {
                ...this.ivrTemplate,
                body: JSON.stringify(flow.body),
              };
              EventBus.$emit('modal', 'Guardado exitoso');
            })
            .catch(() => {
              EventBus.$emit('modal', 'Ocurrio un error al guardar la plantilla. Por favor intente nuevamente');
            })
            .finally(() => {
              this.showChecker = false;
            });
        } else if (this.createStaging) {
          // Creando plantilla para despues la proxima carga
          this.axios.post('templates/staging', {
            type: this.ivrTemplate.type,
            voice: this.ivrTemplate.voice,
            text: JSON.stringify(flow.body),
            template_id: this.ivrTemplate.id,
            company_id: this.$auth.user().company_id,
            channel_id: 3,
          })
            .then(() => {
              this.templates.staging = {
                ...this.ivrTemplate,
                body: JSON.stringify(flow.body),
              };
              this.createStaging = false;
              this.hasStaging = true;
              this.index = 'staging';
              EventBus.$emit('modal', 'Guardado exitoso, los cambios se aplicaran en la siguiente carga');
            })
            .catch(() => {
              EventBus.$emit('modal', 'Ocurrio un error al guardar la plantilla. Por favor intente nuevamente');
            })
            .finally(() => {
              this.showChecker = false;
            });
        } else if (this.hasStaging && this.stagingActive) {
          // Actualizando la plantilla que correra en la proxima carga
          this.axios.patch(`templates/staging/${this.ivrTemplate.id}`, {
            type: this.ivrTemplate.type,
            voice: this.ivrTemplate.voice,
            text: JSON.stringify(flow.body),
            template_id: this.ivrTemplate.id,
            company_id: this.$auth.user().company_id,
            channel_id: 3,
          })
            .then(() => {
              this.templates.staging = {
                ...this.ivrTemplate,
                body: JSON.stringify(flow.body),
              };
              this.index = 'staging';
              EventBus.$emit('modal', 'Guardado exitoso, los cambios se aplicaran en la siguiente carga');
            })
            .catch((error) => {
              console.log(error);
              EventBus.$emit('modal', 'Ocurrio un error al guardar la plantilla. Por favor intente nuevamente');
            })
            .finally(() => {
              this.showChecker = false;
            });
        }
      }
    },
  },
  watch: {
    index() {
      if (Object.keys(this.templates[this.index]).length) {
        this.stagingActive = !this.stagingActive;
        this.setFlow(this.templates[this.index]);
      }
    },
  },
};
</script>

<style scoped>
  #header-container {
    display: flex;
    align-items: center;
    margin-bottom: 2vh !important;
    justify-content: space-between;
  }

  #header-select {
    max-width: 17vw !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/ivr_v2/Detail/Index.vue